import { IStorage } from './types';

export function MemoryStorage<T> (_: string, emptyItem: T): IStorage<T> {
  let storage = emptyItem;

  const get = async (): Promise<T> => {
    return Promise.resolve(storage);
  };

  const set = async (value: T): Promise<void> => {
    storage = value;
    return Promise.resolve();
  };

  return  {
    get,
    set,
  };
}
